import styled from 'styled-components';
import { Input } from '@8powers/ams/components/UI/Form';

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
    margin-left: 4rem;
  }
`;

export const Num = styled.div`
  min-width: 2rem;
  margin-right: 2rem;
  text-align: right;
`;

export const InputWrap = styled.div`
  max-width: ${({ long }) => (long ? '37rem' : '10rem')};
  width: 100%;
  white-space: nowrap;

  & + & {
    margin-left: 2rem;
  }

  ${({ withCurrency }) =>
    withCurrency &&
    `
    position: relative;

    ${Input} {
      text-align: right;
      padding-right: 2.8rem;
    }

    &::after {
      content: 'zł';
      position: absolute;
      right: 1rem;
      bottom: 0.3rem;
      font-weight: 300;
    }
  `}
`;

export const Multiply = styled.div`
  margin-left: 2rem;
  margin-right: 2rem;
  color: #ccc;
`;

export const Sum = styled.div`
  margin-left: ${({ marginLeft }) => (marginLeft ? '2rem' : 0)};
  font-weight: 500;
  white-space: nowrap;
  min-width: 11rem;
  text-align: right;

  ${({ error }) =>
    error &&
    `
    color: red
  `}
`;

export const Actions = styled.div`
  margin-left: 2rem;
`;

export const Button = styled.button`
  border: 0;
  background: transparent;
  user-select: none;
  cursor: pointer;
`;
